import { graphql, useMutation } from 'react-relay/hooks';
import { ONBOARDING_TOOLS, ToolSuggestion } from './toolSuggestion';
import { useSuggestToolMutation } from './__generated__/useSuggestToolMutation.graphql';

export function useSuggestTool() {
    const [commit] = useMutation<useSuggestToolMutation>(graphql`
        mutation useSuggestToolMutation($prompt: String!) {
            suggestOnboardingSolution(prompt: $prompt) {
                toolId
                alternativeToolIds
            }
        }
    `);

    return (prompt: string): Promise<ToolSuggestion> =>
        new Promise((resolve, reject) => {
            commit({
                variables: { prompt },
                onCompleted: (response, errors) => {
                    if (errors?.length) {
                        reject(new Error('Unable to suggest a solution.'));
                        return;
                    }
                    const result = response.suggestOnboardingSolution;
                    const tool = ONBOARDING_TOOLS.find((candidate) => candidate.id === result.toolId);
                    const alternatives = result.alternativeToolIds.map((id) => ONBOARDING_TOOLS.find((candidate) => candidate.id === id));
                    if (
                        !tool ||
                        alternatives.length !== 2 ||
                        alternatives.some((candidate) => !candidate || candidate.id === tool.id) ||
                        new Set(result.alternativeToolIds).size !== 2
                    ) {
                        reject(new Error('Invalid solution recommendation.'));
                        return;
                    }
                    resolve({ tool, alternatives: alternatives.filter((candidate): candidate is NonNullable<typeof candidate> => !!candidate) });
                },
                onError: reject
            });
        });
}
